package com.milta.feature.subscription.data.repository

import com.milta.core.cache.LocalCacheStore
import com.milta.core.network.ApiException
import com.milta.feature.subscription.data.remote.SubscriptionApi
import com.milta.feature.subscription.data.remote.dto.SubmitReceiptRequest
import com.milta.feature.subscription.data.remote.dto.SubscriptionDto
import com.milta.feature.subscription.data.remote.dto.toDomain
import com.milta.feature.subscription.domain.entity.Subscription
import com.milta.feature.subscription.domain.entity.SubscriptionPlanInfo
import com.milta.feature.subscription.domain.repository.SubscriptionRepository
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val SUBSCRIPTION_CACHE_KEY = "cache:subscription"

class SubscriptionRepositoryImpl(
    private val api: SubscriptionApi,
    private val cacheStore: LocalCacheStore,
) : SubscriptionRepository {

    // Mode hors ligne — meme cache-aside que RouteRepositoryImpl.getMyRoute.
    override suspend fun getMySubscription(): Result<Subscription> = runCatching {
        api.getMySubscription()
    }.onSuccess {
        cacheStore.putString(SUBSCRIPTION_CACHE_KEY, Json.encodeToString(it))
    }.recoverCatching { e ->
        if (e is ApiException) throw e
        val cached = cacheStore.getString(SUBSCRIPTION_CACHE_KEY) ?: throw e
        Json.decodeFromString<SubscriptionDto>(cached)
    }.map { it.toDomain() }

    override suspend fun getPlans(): Result<List<SubscriptionPlanInfo>> = runCatching {
        api.getPlans().map { it.toDomain() }
    }

    override suspend fun submitReceipt(
        plan: String,
        platform: String,
        storeProductId: String,
        receiptToken: String,
        amount: Double,
        currency: String,
        storeTransactionId: String,
    ): Result<Subscription> = runCatching {
        api.submitReceipt(
            SubmitReceiptRequest(
                plan = plan,
                platform = platform,
                storeProductId = storeProductId,
                receiptToken = receiptToken,
                amount = amount,
                currency = currency,
                storeTransactionId = storeTransactionId,
            )
        ).toDomain()
    }
}
